export default __webpack_public_path__ + "static/media/f6db00e4d4d5608231111f69aebd9785.png";